export default "__VITE_ASSET__97a500f7__"